import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full'},
  { path: 'login', loadChildren: ()=> import('./login/login.module').then(m => m.LoginModule)},
  { path: 'registerme', loadChildren: ()=> import('./registration/registration.module').then(m => m.RegistrationModule)},
  { path: 'executor-dashboard', loadChildren: () => import('./executor-dashboard/executor-dashboard.module').then(m => m.ExecutorDashboardModule), canActivate: [AuthGuard]},
  { path: 'submit-assessment', loadChildren: () => import('./control-assessment/control-assessment.module').then(m => m.ControlAssessmentModule), canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
